import { render, staticRenderFns } from "./handleList.vue?vue&type=template&id=025f74ec&scoped=true"
import script from "./handleList.vue?vue&type=script&lang=js"
export * from "./handleList.vue?vue&type=script&lang=js"
import style0 from "./handleList.vue?vue&type=style&index=0&id=025f74ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f74ec",
  null
  
)

export default component.exports